<div class="navbar-container">
  <div class="left-navbar-section">
    <a class="logo" href="/">
      <mat-icon svgIcon="sama"></mat-icon>
    </a>
    <ng-content select="[projection-location='left']"></ng-content>
  </div>
  <div class="right-navbar-section">
    <ng-content select="[projection-location='right']"></ng-content>
    @if (isInternalUser$ | async) {
      <h3-debug-logging-button></h3-debug-logging-button>
      <div id="appcues-launchpad"></div>
    }
  </div>
</div>
<div class="navbar-overlay flex-column">
  <h3-navbar-project-status-indicator
    [projectType]="projectType$ | async | lowercase"
    [isProjectPaused]="isProjectPaused$ | async"
  ></h3-navbar-project-status-indicator>
  <div class="navbar-overlay-row">
    <div class="breadcrumbs-container">
      <h3-navigation-breadcrumbs [stepId]="stepId">
        <ng-content select="[projection-location='breadcrumbs']"></ng-content>
      </h3-navigation-breadcrumbs>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon class="material-icons-outlined">expand_more</mat-icon>
      </button>
    </div>

    <mat-menu
      #menu="matMenu"
      class="breadcrumbs-menu large-mat-menu"
      xPosition="before"
    >
      <div
        class="breadcrumbs-menu-content"
        *ngIf="task$ | async"
        (click)="preventExpansionPanelFromClosing($event)"
      >
        <h3-task-id></h3-task-id>
        <div class="divider"></div>
        <h3-client-batch-id></h3-client-batch-id>
        <div class="divider" *ngIf="submissions?.length"></div>
        <h3-submitter-info [submissions]="submissions"></h3-submitter-info>
      </div>
    </mat-menu>
  </div>
</div>
